import type { GetterTree } from 'vuex';
import { FieldPlacementHelper } from '@lib-shared/fields/helpers/field-placement.helper';
import type { IField } from '@lib-shared/fields/types/field';
import { EFieldGetter } from './field.constants';
import type { IFieldState } from './field.types';
import type { IRootState } from '@signing-page/store/store';

export const getters: GetterTree<IFieldState, IRootState> = {
  [EFieldGetter.PositionedFields](state): IField[] {
    return state.fields.map((field: IField) => ({
      ...field,
      position: FieldPlacementHelper.calculateFieldPositionForPlacement(
        field.position,
        state.pageWidth
      ),
    }));
  },
};
